import type { AuthUserEntityStore } from '@/shared/models/authStore.model';
import { useAuthStore } from '@/shared/stores/auth.store';

/**
 * Repositorio centralizado para acceso al AuthStore
 * Cumple con SRP: única fuente de verdad para acceder al store de autenticación
 * Elimina duplicación de código entre múltiples repositorios
 */
class AuthStoreAccessRepository {
  /**
   * Obtiene el estado completo del store de autenticación
   */
  getCurrentAuthState(): AuthUserEntityStore {
    return useAuthStore.getState();
  }

  /**
   * Obtiene solo el token actual del store
   */
  getCurrentToken(): string | null {
    return useAuthStore.getState().token;
  }

  /**
   * Guarda datos de autenticación en el store
   */
  saveAuthData(authData: AuthUserEntityStore): void {
    useAuthStore.getState().login(authData);
  }

  /**
   * Obtiene el estado del store de forma reactiva (para hooks)
   */
  getReactiveAuthState() {
    return useAuthStore();
  }
}

export const authStoreAccessRepository = new AuthStoreAccessRepository();
